module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-8"
  }, [_c('div', {
    staticClass: "card card-default widget animated"
  }, [_c('div', {
    staticClass: "card-heading"
  }, [_c('form', {
    staticClass: "row",
    on: {
      "submit": _vm.createWorkflow
    }
  }, [_c('div', {
    staticClass: "col-md-5 "
  }, [_c('h5', [_vm._v("Information")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('active-form-checkbox', {
    attrs: {
      "label": "Active",
      "name": "active"
    },
    model: {
      value: (_vm.workflow.active),
      callback: function($$v) {
        _vm.$set(_vm.workflow, "active", $$v)
      },
      expression: "workflow.active"
    }
  }), _vm._v(" "), _c('critical-form-checkbox', {
    attrs: {
      "label": "Critical",
      "name": "critical"
    },
    model: {
      value: (_vm.workflow.critical),
      callback: function($$v) {
        _vm.$set(_vm.workflow, "critical", $$v)
      },
      expression: "workflow.critical"
    }
  }), _vm._v(" "), _c('endtimebased-form-checkbox', {
    attrs: {
      "label": "End Time Based",
      "name": "endtimebased"
    },
    model: {
      value: (_vm.workflow.endtimebased),
      callback: function($$v) {
        _vm.$set(_vm.workflow, "endtimebased", $$v)
      },
      expression: "workflow.endtimebased"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('form-text', {
    ref: "name",
    attrs: {
      "label": "Name",
      "name": "name",
      "validation": "required"
    },
    model: {
      value: (_vm.workflow.name),
      callback: function($$v) {
        _vm.$set(_vm.workflow, "name", $$v)
      },
      expression: "workflow.name"
    }
  }), _vm._v(" "), _c('form-textarea', {
    attrs: {
      "label": "Description",
      "name": "description"
    },
    model: {
      value: (_vm.workflow.description),
      callback: function($$v) {
        _vm.$set(_vm.workflow, "description", $$v)
      },
      expression: "workflow.description"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h5', [_vm._v("Warn Before")]), _vm._v(" "), _c('p', [_vm._v("* Give a minute value for how long before this workflow is due that there should be a warning (if this isn't set, it will use device settings)")]), _vm._v(" "), _c('form-textnumber', {
    ref: "warnbefore",
    attrs: {
      "label": "Warn Before",
      "name": "warnbefore",
      "validation": "numeric"
    },
    model: {
      value: (_vm.workflow.warnBefore),
      callback: function($$v) {
        _vm.$set(_vm.workflow, "warnBefore", $$v)
      },
      expression: "workflow.warnBefore"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h5', [_vm._v("Schedule")]), _vm._v(" "), _c('p', [_vm._v("* Give a minute value for how often the workflow should be completed. (Ex: input 60 for an hour)")]), _vm._v(" "), _c('form-textnumber', {
    ref: "schedule",
    attrs: {
      "label": "Schedule",
      "name": "schedule",
      "validation": "required"
    },
    model: {
      value: (_vm.workflow.schedule),
      callback: function($$v) {
        _vm.$set(_vm.workflow, "schedule", $$v)
      },
      expression: "workflow.schedule"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 offset-md-1"
  }, [_c('h5', [_vm._v("Tasks")]), _vm._v(" "), _c('p', [_vm._v("* Click and drag tasks to reorder")]), _vm._v(" "), (_vm.org['curOrg']['role'] == 99) ? _c('div', [(!_vm.tasksJsonView) ? _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.tasksJsonView = true
      }
    }
  }, [_vm._v("JSON View")]) : _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.tasksJsonView = false
      }
    }
  }, [_vm._v("Normal View")])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.tasks.length) + " Tasks")]), _vm._v(" "), (!_vm.tasksJsonView) ? _c('div', [_c('draggable', {
    attrs: {
      "list": _vm.tasks
    },
    on: {
      "end": _vm.reOrderTask
    }
  }, _vm._l((_vm.tasks), function(task) {
    return _c('div', {
      staticClass: "list-group"
    }, _vm._l((task), function(element) {
      return _c('div', {
        staticClass: "list-group-item"
      }, [(element.name == 'Location Tag') ? _c('div', [_c('div', {
        staticClass: "d-flex w-100 justify-content-between"
      }, [_c('p', {
        staticStyle: {
          "font-size": "15px"
        }
      }, [_vm._v(_vm._s(element.name))])]), _vm._v(" "), _c('small', [_vm._v("Speak Text: " + _vm._s(element.speak))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', {}, [_vm._v("Tag Name: " + _vm._s(element.description))])]) : (element.name == 'Input') ? _c('div', [_c('div', {
        staticClass: "d-flex w-100 justify-content-between"
      }, [_c('p', {
        staticStyle: {
          "font-size": "15px"
        }
      }, [_vm._v(_vm._s(element.name))])]), _vm._v(" "), _c('small', [_vm._v("Type: " + _vm._s(_vm.inputTypes.find(function(inputType) {
        return inputType['.key'] == element.type
      })['name']))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', {}, [_vm._v("Name: " + _vm._s(element.description))])]) : (element.name == 'Temperature') ? _c('div', [_c('div', {
        staticClass: "d-flex w-100 justify-content-between"
      }, [_c('p', {
        staticStyle: {
          "font-size": "15px"
        }
      }, [_vm._v(_vm._s(element.name))])]), _vm._v(" "), _c('small', {}, [_vm._v("Name: " + _vm._s(element.description))])]) : _vm._e()])
    }), 0)
  }), 0)], 1) : _c('div', [_c('pre', [_vm._v(_vm._s(_vm._f("pretty")(_vm.tasks)))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#createTaskModal"
    }
  }, [_vm._v("Add Task")]), _vm._v(" "), (_vm.org['curOrg']['role'] == 99) ? _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#addJsonTasksModal"
    }
  }, [_vm._v("Add JSON Tasks")]) : _vm._e()])])])])])]), _vm._v(" "), _c('createtask', {
    attrs: {
      "name": "createTaskModal"
    },
    on: {
      "addTask": _vm.addTask
    }
  }), _vm._v(" "), _c('addjsontasks', {
    attrs: {
      "name": "addJsonTasksModal"
    },
    on: {
      "addJsonTasks": _vm.addJsonTasks
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-success btn-lg",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Create")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7494df07","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/operations/Workflows/CreateWorkflow.vue
// module id = 648
// module chunks = 1